import React, { useEffect, useState } from "react";
import Winwheel from "winwheel";
import image from "../../../../styles/img/user.jpg";
import Pointer from '../../../../styles/img/basic_pointer.png'

export default function Wheel() {
    const [wheelSpinning, setWheelSpinning] = useState(false);

    useEffect(function () {
        window.winwheel = new Winwheel({
            canvasId: "canvas",
            numSegments: 8,
            segments: [
                { fillStyle: "#eae56f", text: "Prize One" },
                { fillStyle: "#89f26e", text: "Prize Two" },
                { fillStyle: "#7de6ef", text: "Prize Three" },
                { fillStyle: "#e7706f", text: "Prize Four" },
                { fillStyle: "#eae56f", text: "Prize Five" },
                { fillStyle: "#89f26e", text: "Prize Six" },
                { fillStyle: "#7de6ef", text: "Prize Seven" },
                { fillStyle: "#e7706f", text: "Prize Eight" },
            ],
            lineWidth: 1,
            animation: {
                type: "spinToStop",
                duration: 8,
                spins: 10,
                callbackFinished: "alertPrize()",
                callbackAfter: function () {
                    alert("dd");
                },
            },
        });

        // drawTriangle();
    }, []);

    function calculatePrize() {
        var stopAt = window.winwheel.getRandomForSegment(4);
        window.winwheel.animation.stopAngle = stopAt;
        window.winwheel.startAnimation();
    }

    window.alertPrize = function () {
        let winningSegment = window.winwheel.getIndicatedSegment();
        alert("You have won " + winningSegment.text + "!");
        // }
    };

    function startSpin() {
        calculatePrize();
        // window.winwheel.startAnimation();
    }

    function reset() {
        window.winwheel.stopAnimation(false);
        window.winwheel.rotationAngle = 0;
    }

    function drawTriangle() {
        if (typeof window.winwheel != "undefined") {
            // Get the canvas context the wheel uses.
            let ctx = window.winwheel.ctx;

            ctx.strokeStyle = "navy"; // Set line colour.
            ctx.fillStyle = "aqua"; // Set fill colour.
            ctx.lineWidth = 2;
            ctx.beginPath(); // Begin path.
            ctx.moveTo(170, 5); // Move to initial position.
            ctx.lineTo(230, 5); // Draw lines to make the shape.
            ctx.lineTo(200, 40);
            ctx.lineTo(171, 5);
            ctx.stroke(); // Complete the path by stroking (draw lines).
            ctx.fill(); // Then fill.
        }
    }

    return (
        <>
        <div id="canvasContainer">
    <canvas id="canvas" width="880" height="300">
        Canvas not supported, please user another browser.
    </canvas>
    <img id="prizePointer" src={Pointer} alt="V" />
    <button onClick={startSpin}>Spin the Wheel</button>
            <br />
            <button onClick={reset}>Reset</button>
</div>

            {/* <canvas id="myCanvas" width="880" height="300">
                xzx
            </canvas> */}
           
        </>
    );
}
